import { ReviewRes } from 'services/api/dashboard';

export default function convertData(input: ReviewRes): Partial<Dashboard.ReviewInner> {
  const { buyerComment, replyComment, praiseReminder, fixCommentReminder } = input;
  const totalComment = (buyerComment?.badCommentCount ?? 0) + (buyerComment?.goodCommentCount ?? 0);
  const totalReplyComment =
    (replyComment?.botReplyCommentCount ?? 0) + (replyComment?.assistantReplyCommentCount ?? 0);

  const badCommentRate = (buyerComment?.badCommentCount ?? 0) / totalComment;
  const assistantReplyCommentRate =
    (replyComment?.assistantReplyCommentCount ?? 0) / totalReplyComment;
  const reminderSuccessRate =
    (praiseReminder?.praiseReminderTradeIsConvertCount ?? 0) /
    (praiseReminder?.praiseReminderTradeCount || 0);
  const fixedRate =
    (fixCommentReminder?.fixCommentReminderGotReplyAndGoodCommentCount ?? 0) /
    (fixCommentReminder?.fixCommentReminderTradeCount || 0);
  return {
    中差评: buyerComment?.badCommentCount,
    好评: buyerComment?.goodCommentCount,
    中差评订单率: badCommentRate,
    好评订单率: 1 - badCommentRate,

    人工回评: replyComment?.assistantReplyCommentCount,
    机器人自动回评: replyComment?.botReplyCommentCount,
    人工回评率: assistantReplyCommentRate,
    机器人自动回评率: 1 - assistantReplyCommentRate,

    自动催好评订单数: praiseReminder?.praiseReminderTradeCount,
    自动催好评成功数: praiseReminder?.praiseReminderTradeIsConvertCount,
    自动催好评成功率: reminderSuccessRate,
    发起中差评挽回数: fixCommentReminder?.fixCommentReminderTradeCount,
    成功挽回中差评数: fixCommentReminder?.fixCommentReminderGotReplyAndGoodCommentCount,
    买家响应数: fixCommentReminder?.fixCommentReminderGotReplyCount,
    中差评挽回率: fixedRate,
    买家评价领先率: buyerComment?.overallBeatRatio,
    自动催好评领先率: praiseReminder?.overallBeatRatio,
    中差评挽回领先率: fixCommentReminder?.overallBeatRatio,
  };
}
